export default "__VITE_ASSET__C3yoc50v__"